import { React, useEffect, } from 'react';
import PhotoPlaceholder from '../PagesClaude/placeholder';



const Shop = ({ pages, openLightbox, images }) => {
	
	const archiveById = Object.fromEntries(images.map((p) => [p.id, p]));
	
	useEffect(() => {
		window.scrollTo(0,0);
	}, []);
	

	
	return (
		<main className="wi-shop">

			<header className="wi-shop-head">
				<div className="wi-mono wi-eyebrow" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "editions-top").dataJson.country}}></div>
				<h1 className="wi-shop-title" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "editions-top").subtitle}}></h1>
				<p className="wi-shop-lede" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "editions-top").description}}></p>
			</header>

			{ (images.length > 0 || 1===2 ) && 
				<>
					<div className="wi-shop-grid">
						{images.map((pr, i) => {
							const p = archiveById[pr.id];
							return (
								<article key={pr.pricingsJson.sku} className="wi-print">
									<button
										className="wi-print-frame"
										onClick={() => openLightbox(p.id, images)}
									>
										<PhotoPlaceholder
											src={p.cdnUrl}
											caption={p.title}
											ratio={p.ratio}
											index={i + 30}
											showMeta={false}
											imgStyle={{objectFit: "contain", filter: 'none'}}
										/>
									</button>
									<div className="wi-print-meta">
										<div className="wi-print-row">
											<span className="wi-mono wi-print-sku">{pr.pricingsJson.sku}</span>
											<span className="wi-mono wi-print-edition">{pr.pricingsJson.name}</span>
										</div>
										<h3 hidden className="wi-print-title">{p.title}</h3>
										<div className="wi-print-place">
											{p.title} · {pr.country} · {p.date_content.split('-')[2]}
										</div>
										<div className="wi-print-buy">
										<div>
											<div className="wi-mono wi-meta-k">Size</div>
											<div className="wi-meta-v">{pr.pricingsJson.info}</div>
										</div>
										<div>
											<div className="wi-mono wi-meta-k">Price</div>
											<div className="wi-meta-v">{pr.pricingsJson.price} €</div>
										</div>
										<a href={pr.pricingsJson.buyUrl} className="wi-btn-sm" target='_blank' rel="noreferrer">
											Buy <span aria-hidden>→</span>
										</a>
										</div>
									</div>
								</article>
							);
						})}
					</div>
					
					<section className="wi-shop-note">
						<div className="wi-mono wi-eyebrow" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "editions-bottom").subtitle}}></div>
						<p data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "editions-bottom").description}}></p>
					</section>

				</>
			}

		</main>
		);
	};
	
	export default Shop;
